module.exports = __webpack_public_path__ + "bcc3dc33da17bee3040a25764337ee24.svg";